import type { UltrareviewPromo } from './promo/promo';

import { ReviewMode } from '@/generated/prisma/enums';

/**
 * Reviewed-line quota multiplier applied to ultrareview runs. Ultrareviews are
 * far more expensive than standard reviews, so they consume the installation's
 * monthly reviewed-lines quota at this rate.
 *
 * The rate is pinned per run on `ReviewRun.quotaLineMultiplier` at creation
 * (see initiate-pr-review/review-run-persistence.ts), so changing this
 * constant only re-prices future runs — billed history never changes.
 */
export const ULTRAREVIEW_LINE_QUOTA_MULTIPLIER = 3;

/** Only paid ultrareviews bill at the multiplier; free promo ultrareviews bill at the standard rate. */
export function reviewQuotaLineMultiplier(
  mode: ReviewMode,
  promo: UltrareviewPromo | null,
): number {
  return mode === ReviewMode.ULTRAREVIEW && !promo ? ULTRAREVIEW_LINE_QUOTA_MULTIPLIER : 1;
}
